import React from "react";
import "./../../css/ResultBarChart.css";
import "./../../css/HomeResults.css";
const ResultBarChart = ({ title, rate }) => {
  return (
    <div className='result-chart'>
      <div className='result-chart-header'>
        <span className='result-chart-title'>{title}</span>
        <span className='result-chart-rate'>{rate}%</span>
      </div>
      <div className='result-chart-bar'>
        <div className='result-chart-fill' style={{ width: `${rate}%` }}></div>
      </div>
    </div>
  );
};

export default ResultBarChart;
